import request from '@/utils/request'

export const getReportCatalog = () => {
  return request({
    url: '/api/reports/catalog',
    method: 'get',
  })
}

export const getReportWarehouses = () => {
  return request({
    url: '/api/reports/warehouses',
    method: 'get',
  })
}

/** 品名库存货值：历史报表列表 */
export const listInventoryCategoryValueReports = (params = {}) => {
  return request({
    url: '/api/reports/inventory-by-category',
    method: 'get',
    params,
  })
}

/** 品名库存货值：按当前实库生成快照 */
export const createInventoryCategoryValueReport = (data = {}) => {
  return request({
    url: '/api/reports/inventory-by-category',
    method: 'post',
    data,
  })
}

/** 品名库存货值：详情 */
export const getInventoryCategoryValueReport = (reportId) => {
  return request({
    url: `/api/reports/inventory-by-category/${reportId}`,
    method: 'get',
  })
}

/** 品名库存货值：保存本单单价 */
export const saveInventoryCategoryValuePrices = (reportId, items) => {
  return request({
    url: `/api/reports/inventory-by-category/${reportId}/prices`,
    method: 'put',
    data: { items },
  })
}

/** 品名库存货值：套用历史单价到本单 */
export const applyInventoryCategoryValueHistoricalPrices = (reportId, data = {}) => {
  return request({
    url: `/api/reports/inventory-by-category/${reportId}/apply-prices`,
    method: 'post',
    data,
  })
}

/** 品名库存货值：导出 Excel */
export const exportInventoryCategoryValueReport = (reportId) => {
  return request({
    url: `/api/reports/inventory-by-category/${reportId}/export`,
    method: 'get',
    responseType: 'blob',
  })
}

export const getGainLossReconciliation = (params = {}) => {
  return request({
    url: '/api/reports/gain-loss-reconciliation',
    method: 'get',
    params,
  })
}

export const getColorCardReport = (params = {}) => {
  return request({
    url: '/api/reports/color-card',
    method: 'get',
    params,
  })
}

export const exportColorCardReport = (params = {}) => {
  return request({
    url: '/api/reports/color-card/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

/** 盘点未盖章报表 */
export const getStockTakeUnstampedReport = (params = {}) => {
  return request({
    url: '/api/reports/stock-take-unstamped',
    method: 'get',
    params,
  })
}

export const exportStockTakeUnstampedReport = (params = {}) => {
  return request({
    url: '/api/reports/stock-take-unstamped/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

export const getGainLossReconciliationDetails = (params = {}) => {
  return request({
    url: '/api/reports/gain-loss-reconciliation/details',
    method: 'get',
    params,
  })
}

export const getGrossProfitReport = (params = {}) => {
  return request({
    url: '/api/reports/gross-profit',
    method: 'get',
    params,
  })
}

export const exportGrossProfitReport = (params = {}) => {
  return request({
    url: '/api/reports/gross-profit/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

/** 毛利报表：保存订单明细采购成本归属 shared|dedicated */
export const saveGrossProfitCostAllocation = (data) => {
  return request({
    url: '/api/reports/gross-profit/cost-allocation',
    method: 'put',
    data,
  })
}

/** 毛利报表：仓库料号剩余库存是否并入订单均摊 */
export const saveGrossProfitLotCostSetting = (data) => {
  return request({
    url: '/api/reports/gross-profit/lot-cost-setting',
    method: 'put',
    data,
  })
}

export const getBrandSeasonMeta = () => {
  return request({
    url: '/api/reports/brand-season/meta',
    method: 'get',
  })
}

export const getBrandSeasonPreview = (params = {}) => {
  return request({
    url: '/api/reports/brand-season',
    method: 'get',
    params,
  })
}

export const exportBrandSeasonReport = (params = {}) => {
  return request({
    url: '/api/reports/brand-season/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

export const getBrandSeasonProfile = (params = {}) => {
  return request({
    url: '/api/reports/brand-season/profile',
    method: 'get',
    params,
  })
}

export const saveBrandSeasonProfile = (data = {}) => {
  return request({
    url: '/api/reports/brand-season/profile',
    method: 'post',
    data,
  })
}

export const listBrandSeasonCategoryAliases = (params = {}) => {
  return request({
    url: '/api/reports/brand-season/category-aliases',
    method: 'get',
    params,
  })
}

export const saveBrandSeasonCategoryAlias = (data = {}) => {
  return request({
    url: '/api/reports/brand-season/category-aliases',
    method: 'post',
    data,
  })
}

export const deleteBrandSeasonCategoryAlias = (id) => {
  return request({
    url: `/api/reports/brand-season/category-aliases/${id}`,
    method: 'delete',
  })
}

export const listBrandSeasonCustomerPortals = (params = {}) => {
  return request({
    url: '/api/reports/brand-season/customer-portals',
    method: 'get',
    params,
  })
}

export const saveBrandSeasonCustomerPortal = (data = {}) => {
  return request({
    url: '/api/reports/brand-season/customer-portals',
    method: 'post',
    data,
  })
}

export const deleteBrandSeasonCustomerPortal = (id) => {
  return request({
    url: `/api/reports/brand-season/customer-portals/${id}`,
    method: 'delete',
  })
}

export const listBrandSeasonSaved = () => {
  return request({
    url: '/api/reports/brand-season/saved',
    method: 'get',
  })
}

export const saveBrandSeasonSaved = (data = {}) => {
  return request({
    url: '/api/reports/brand-season/saved',
    method: 'post',
    data,
  })
}

export const getBrandSeasonSaved = (reportId, params = {}) => {
  return request({
    url: `/api/reports/brand-season/saved/${reportId}`,
    method: 'get',
    params,
  })
}

export const refreshBrandSeasonSaved = (reportId) => {
  return request({
    url: `/api/reports/brand-season/saved/${reportId}/refresh`,
    method: 'post',
  })
}

export const deleteBrandSeasonSaved = (reportId) => {
  return request({
    url: `/api/reports/brand-season/saved/${reportId}`,
    method: 'delete',
  })
}

export const exportBrandSeasonSaved = (reportId) => {
  return request({
    url: `/api/reports/brand-season/saved/${reportId}/export`,
    method: 'get',
    responseType: 'blob',
  })
}

/** 品牌季度报表回写：dryRun=true 仅预览；false 确认写入
 * stageResolutions: { [excel_row]: { stage_id } | { create_stage_name } }
 * itemResolutions: { [excel_row]: { order_item_id } }
 */
export const importBrandSeasonWriteback = (
  file,
  { dryRun = true, brandId = null, stageResolutions = null, itemResolutions = null } = {}
) => {
  const form = new FormData()
  form.append('file', file)
  form.append('dry_run', dryRun ? '1' : '0')
  if (brandId != null && brandId !== '') {
    form.append('brand_id', String(brandId))
  }
  if (stageResolutions && typeof stageResolutions === 'object' && Object.keys(stageResolutions).length) {
    form.append('stage_resolutions', JSON.stringify(stageResolutions))
  }
  if (itemResolutions && typeof itemResolutions === 'object' && Object.keys(itemResolutions).length) {
    form.append('item_resolutions', JSON.stringify(itemResolutions))
  }
  return request({
    url: '/api/reports/brand-season/import-writeback',
    method: 'post',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
